import { Graph, Node } from '@antv/x6'
import { TextNodeState } from "../services/modal"
import isObject from 'lodash-es/isObject'
import Quill from "quill"
import "./style.less"

export const TextNode = ({node, graph}: {node: Node, graph: Graph}) => {
  const data: TextNodeState = node.getData()
  const { text: value } = data
  let html = value
  if (isObject(value)) {
    html = quillGetHTML(value)
  }

  return (
    <div dangerouslySetInnerHTML={{__html: html || 'Input text'}} className="ql-view-container">
    </div>
  );
}

function quillGetHTML(inputDelta) {
    var tempCont = document.createElement("div");
    (new Quill(tempCont)).setContents(inputDelta);
    return tempCont.getElementsByClassName("ql-editor")[0].innerHTML;
}
